import React,{ useState } from 'react'
import Modal from 'jd-library/Modal';
import InputWithMovingLabel from 'jd-library/InputWithMovingLabel';
import Button from 'jd-library/Button';
import { Regex } from '../../utills';
import styles from './buy-online-url-modal.scss'


const BuyOnlineUrlModal = (props) => {
    const [url, setUrl] = useState(props.url);
    const [error, setError] = useState(false);
    const [showLoader, setLoader] = useState(false);

    const onSave = () => {
        if(url && !Regex.urlRegex.test(url)){
            setError('Please Enter Valid URL')
            props.showToastMessage({
                showToastMessage: true,
                message: 'Please Enter Valid URL',
                duration: 5000
            });
            return;
        }
        setLoader(true);
        props.onSave(url);
    }

    return(
        <Modal
            settings= {{
                modalId: 'buyOnlineUrlModal',
                variant: 'action',
                class: styles['buy-online-url-modal'],
            }}
            onHidden={props.onHidden} 
        >
            <Modal.CloseIcon
                iconClass={'icon-HDRcross'}
            />
            <Modal.Header>{props.url ? 'Edit Buy Online URL' : 'Add Buy Online URL'}</Modal.Header>
            <Modal.Body className={styles['online-url-modal-body']}>
                <div className={styles['input-container']}>
                    <InputWithMovingLabel 
                        label='Buy Online URL'
                        key=''
                        input={{
                            value: url,
                            autoFocus: true,
                            onChange: (e)=>{
                                setUrl(e.target.value)
                                setError('');
                            }
                        }}
                        errorMessage={error}
                        holderClass={styles['url-field']}
                    />
                </div>
                <Button
                    size='lg'
                    block
                    showLoader={showLoader}
                    onClick={() => onSave()}
                >
                    Save
                </Button>
            </Modal.Body>
        </Modal>
    )
}

export default BuyOnlineUrlModal